import { render, staticRenderFns } from "./QrCodeScannerWrapper.vue?vue&type=template&id=965fd14c&scoped=true&"
import script from "./QrCodeScannerWrapper.vue?vue&type=script&lang=ts&"
export * from "./QrCodeScannerWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./QrCodeScannerWrapper.vue?vue&type=style&index=0&id=965fd14c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965fd14c",
  null
  
)

export default component.exports